import { render, staticRenderFns } from "./DeliveryOrders.vue?vue&type=template&id=09a1203c&"
import script from "./DeliveryOrders.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports